import { Description } from '@heroui/react';
import { formatDateBR, formatTimeBR } from '../../utils/date-utils';

export function DateTimeFrame({
  label,
  iso,
  className = 'min-w-0 flex-1 px-0.5',
}: {
  label: string;
  iso: string;
  className?: string;
}) {
  return (
    <div className={className}>
      <Description className="text-xs font-medium uppercase tracking-wide text-muted">
        {label}
      </Description>
      <p className="mt-1 text-sm font-bold tabular-nums text-foreground">{formatDateBR(iso)}</p>
      <p className="text-base font-bold tabular-nums text-foreground">{formatTimeBR(iso)}</p>
    </div>
  );
}
